import TreeNodeRenderer from 'components/PageComponents/Plans/Edit/components/ObjectivesList/ObjectivesTreeTheme/TreeNodeRenderer'
import NodeContentRenderer from './NodeContentRenderer'

const theme = {
  scaffoldBlockPxWidth: 24,
  treeNodeRenderer: TreeNodeRenderer,
  nodeContentRenderer: NodeContentRenderer
}

export default theme
